import React from 'react'

type Direction = 'left' | 'right'
type ArrowSize = 'sm' | 'md'

const SIZE_CLASSES: Record<ArrowSize, { button: string; icon: string }> = {
  sm: { button: 'w-8 h-8', icon: 'h-5 w-5' },
  md: { button: 'w-12 h-12', icon: 'h-8 w-8' },
}

export interface NavigationArrowProps {
  direction: Direction
  onClick: (e: React.MouseEvent) => void
  className?: string
  ariaLabel?: string
  /** Button size – `sm` (32 px) or `md` (48 px, default). */
  size?: ArrowSize
}

/**
 * Reusable navigation arrow button used in PhotoDisplayer and post image galleries.
 * Renders a round semi-transparent button with a chevron SVG.
 */
export const NavigationArrow: React.FC<NavigationArrowProps> = ({
  direction,
  onClick,
  className = '',
  ariaLabel,
  size = 'md',
}) => {
  const label =
    ariaLabel ?? (direction === 'left' ? 'Poprzednie zdjęcie' : 'Następne zdjęcie')
  const s = SIZE_CLASSES[size]

  return (
    <button
      onClick={onClick}
      className={`flex items-center justify-center ${s.button} rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors backdrop-blur-sm ${className}`}
      aria-label={label}
    >
      {direction === 'left' ? (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={s.icon}>
          <path d="M15.75 19.5 8.25 12l7.5-7.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={s.icon}>
          <path d="m8.25 4.5 7.5 7.5-7.5 7.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
    </button>
  )
}
